import React from 'react';
import AddNewInstitutionDialog
  from 'Views/Page/Content/Modal/Layouts/AddNewInstitutionLayout/Layout/AddNewInstitutionDialog';

const Layout = () => {
  return (
    <AddNewInstitutionDialog isWizardStep />
  );
};

export default Layout;
